{
  "CAMPAIGN": {
    "LIVE_CHAT": {
      "HEADER_TITLE": "Campanhas de chat ao vivo",
      "NEW_CAMPAIGN": "Criar campanha",
      "CARD": {
        "STATUS": {
          "ENABLED": "Ativado",
          "DISABLED": "Desativado"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_BY": "Enviado por",
          "BOT": "Robôs",
          "FROM": "De",
          "URL": "URL:"
        }
      },
      "EMPTY_STATE": {
        "TITLE": "Não há campanhas de chat ao vivo disponíveis",
        "SUBTITLE": "Conecte-se com seus clientes usando mensagens proativas. Clique em 'Criar campanha' para começar."
      },
      "CREATE": {
        "TITLE": "Criar uma campanha de chat ao vivo",
        "CANCEL_BUTTON_TEXT": "Cancelar",
        "CREATE_BUTTON_TEXT": "Criar",
        "FORM": {
          "TITLE": {
            "LABEL": "Título",
            "PLACEHOLDER": "Por favor, digite o título da campanha",
            "ERROR": "Título é obrigatório"
          },
          "MESSAGE": {
            "LABEL": "Mensagem",
            "PLACEHOLDER": "Por favor, insira a mensagem da campanha",
            "ERROR": "A mensagem é obrigatória"
          },
          "INBOX": {
            "LABEL": "Selecionar caixa de entrada",
            "PLACEHOLDER": "Selecionar caixa de entrada",
            "ERROR": "Caixa de entrada obrigatória"
          },
          "SENT_BY": {
            "LABEL": "Enviado por",
            "PLACEHOLDER": "Por favor, selecione o remetente",
            "ERROR": "Remetente é obrigatório"
          },
          "END_POINT": {
            "LABEL": "URL:",
            "PLACEHOLDER": "Por favor, insira a URL",
            "ERROR": "Por favor, insira uma URL válida"
          },
          "TIME_ON_PAGE": {
            "LABEL": "Tempo na página (segundos)",
            "PLACEHOLDER": "Por favor insira a hora",
            "ERROR": "Tempo na página é necessário"
          },
          "OTHER_PREFERENCES": {
            "TITLE": "Outras preferências",
            "ENABLED": "Ativar campanha",
            "TRIGGER_ONLY_BUSINESS_HOURS": "Ativar somente durante o horário comercial"
          },
          "BUTTONS": {
            "CREATE": "Criar",
            "CANCEL": "Cancelar"
          },
          "API": {
            "SUCCESS_MESSAGE": "Campanha do chat ao vivo criada com sucesso",
            "ERROR_MESSAGE": "Houve um erro. Por favor, tente novamente."
          }
        }
      },
      "EDIT": {
        "TITLE": "Editar campanha de chat ao vivo",
        "FORM": {
          "API": {
            "SUCCESS_MESSAGE": "Campanha do chat ao vivo atualizada com sucesso",
            "ERROR_MESSAGE": "Houve um erro. Por favor, tente novamente."
          }
        }
      }
    },
    "SMS": {
      "HEADER_TITLE": "Campanhas SMS",
      "NEW_CAMPAIGN": "Criar campanha",
      "EMPTY_STATE": {
        "TITLE": "Não há campanhas SMS disponíveis",
        "SUBTITLE": "Lance uma campanha de SMS para chegar diretamente aos seus clientes. Envie ofertas ou faça anúncios com facilidade. Clique em 'Criar campanha' para começar."
      },
      "CARD": {
        "STATUS": {
          "PROCESSING": "Processando",
          "COMPLETED": "Concluído",
          "SCHEDULED": "Agendada"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_FROM": "Enviado de",
          "ON": "ativado"
        }
      },
      "CREATE": {
        "TITLE": "Criar uma campanha de SMS",
        "CANCEL_BUTTON_TEXT": "Cancelar",
        "CREATE_BUTTON_TEXT": "Criar",
        "FORM": {
          "TITLE": {
            "LABEL": "Título",
            "PLACEHOLDER": "Por favor, digite o título da campanha",
            "ERROR": "Título é obrigatório"
          },
          "MESSAGE": {
            "LABEL": "Mensagem",
            "PLACEHOLDER": "Por favor, insira a mensagem da campanha",
            "ERROR": "A mensagem é obrigatória"
          },
          "INBOX": {
            "LABEL": "Selecionar caixa de entrada",
            "PLACEHOLDER": "Selecionar caixa de entrada",
            "ERROR": "Caixa de entrada obrigatória"
          },
          "AUDIENCE": {
            "LABEL": "Público",
            "PLACEHOLDER": "Selecionar etiquetas dos clientes",
            "ERROR": "Público é necessário"
          },
          "SCHEDULED_AT": {
            "LABEL": "Horário agendado",
            "PLACEHOLDER": "Por favor insira a hora",
            "ERROR": "Horário agendado é necessário"
          },
          "BUTTONS": {
            "CREATE": "Criar",
            "CANCEL": "Cancelar"
          },
          "API": {
            "SUCCESS_MESSAGE": "Campanha SMS criada com sucesso",
            "ERROR_MESSAGE": "Houve um erro. Por favor, tente novamente."
          }
        }
      }
    },
    "WHATSAPP": {
      "HEADER_TITLE": "Campanhas do WhatsApp",
      "NEW_CAMPAIGN": "Criar campanha",
      "EMPTY_STATE": {
        "TITLE": "Nenhuma campanha do WhatsApp está disponível",
        "SUBTITLE": "Inicie uma campanha do WhatsApp para atingir seus clientes diretamente. Envie ofertas ou faça anúncios facilmente. Clique em \"Criar campanha\" para começar."
      },
      "CARD": {
        "STATUS": {
          "PROCESSING": "Processando",
          "COMPLETED": "Concluído",
          "SCHEDULED": "Agendada"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_FROM": "Enviado de",
          "ON": "ativado"
        }
      },
      "CREATE": {
        "TITLE": "Criar campanha do WhatsApp",
        "CANCEL_BUTTON_TEXT": "Cancelar",
        "CREATE_BUTTON_TEXT": "Criar",
        "FORM": {
          "TITLE": {
            "LABEL": "Título",
            "PLACEHOLDER": "Por favor, digite o título da campanha",
            "ERROR": "Título é obrigatório"
          },
          "INBOX": {
            "LABEL": "Selecione uma caixa de entrada",
            "PLACEHOLDER": "Selecione uma caixa de entrada",
            "ERROR": "Caixa de entrada obrigatória"
          },
          "TEMPLATE": {
            "LABEL": "Modelo do WhatsApp",
            "PLACEHOLDER": "Selecione um modelo",
            "INFO": "Selecione um modelo para usar para esta campanha.",
            "ERROR": "Modelo é obrigatório",
            "PREVIEW_TITLE": "Processar {templateName}",
            "LANGUAGE": "Idioma",
            "CATEGORY": "Categorias",
            "VARIABLES_LABEL": "Variáveis",
            "VARIABLE_PLACEHOLDER": "Digite um valor para {variable}"
          },
          "AUDIENCE": {
            "LABEL": "Público",
            "PLACEHOLDER": "Selecionar etiquetas dos clientes",
            "ERROR": "Público é necessário"
          },
          "SCHEDULED_AT": {
            "LABEL": "Horário agendado",
            "PLACEHOLDER": "Por favor insira a hora",
            "ERROR": "Horário agendado é necessário"
          },
          "BUTTONS": {
            "CREATE": "Criar",
            "CANCEL": "Cancelar"
          },
          "API": {
            "SUCCESS_MESSAGE": "Campanha do WhatsApp criada com sucesso",
            "ERROR_MESSAGE": "Houve um erro. Por favor, tente novamente."
          }
        }
      }
    },
    "CONFIRM_DELETE": {
      "TITLE": "Você tem certeza que deseja excluir?",
      "DESCRIPTION": "A ação de exclusão é permanente e não pode ser revertida.",
      "CONFIRM": "Excluir",
      "API": {
        "SUCCESS_MESSAGE": "Campanha excluída com sucesso",
        "ERROR_MESSAGE": "Houve um erro. Por favor, tente novamente."
      }
    }
  }
}
